<div [class]="divClass">
  <label *ngIf="showLabel" [class]="labelClass">{{ 'DropDowns.Label.Tenant' | translate }}</label>

  <laas-multiSelect
    *ngIf="isMultiple"
    appendTo="body"
    [style]="dropdownStyle"
    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
    [filter]="showFilter"
    [options]="tenantOptionsByPermission"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange($event)"
    [virtualScroll]="virtualScroll"
    [itemSize]="40"
    [showToggleAll]="showToggleAll">

    <ng-template pTemplate="selectedItems" let-value>
      <ng-container *ngIf="!value || value.length === 0; else showData">
        <span>
          {{ 'Common.Message.ChooseOption' | translate }}
        </span>
      </ng-container>
      <ng-template #showData>
        <span *ngFor="let val of value; first as isFirst">
          <ng-container *ngIf="!isFirst">, </ng-container>
          {{ val | optionsMapping : tenantOptionsByPermission }}
        </span>
      </ng-template>
    </ng-template>

  </laas-multiSelect>

  <laas-dropdown
    *ngIf="isSingle"
    appendTo="body"
    [style]="dropdownStyle"
    [filter]="showFilter"
    placeholder="{{ 'Common.DropDown.Select' | translate}}"
    [options]="tenantOptionsByPermission"
    [showClear]="showClear"
    [virtualScrollItemSize]="40"
    [virtualScroll]="virtualScroll"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange($event)">
  </laas-dropdown>
</div>
